import IncentivesDashboard from "../../../../features/incentives/IncentivesDashboard";

export default function PointsManagement({activeTab: parentTab}) {
  if (parentTab !== "4") {
    return null;
  }

  return <IncentivesDashboard />;
}
